import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, useNavigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { HomePage } from "@/pages/HomePage";
import { SavedPage } from "@/pages/SavedPage";
import { SharedListPage } from "@/pages/SharedListPage";
import { AdminPage } from "@/pages/AdminPage";
import { GuidelinesPage } from "@/pages/GuidelinesPage";
import { PrivacyPage } from "@/pages/PrivacyPage";
import { StoryPage } from "@/pages/StoryPage";
import { AppLoginPage } from "@/pages/AppLoginPage";
import { AuthCallback } from "@/components/AuthCallback";
import { AuthProvider } from "@/context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
function AppRouter() {
  const location = useLocation();
  
  // Check URL fragment for session_id - must be synchronous during render
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/saved" element={<SavedPage />} />
      <Route path="/shared/:listId" element={<SharedListPage />} />
      <Route path="/admin" element={<AdminPage />} />
      <Route path="/guidelines" element={<GuidelinesPage />} />
      <Route path="/privacy" element={<PrivacyPage />} />
      <Route path="/story/:id" element={<StoryPage />} />
      <Route path="/app-login" element={<AppLoginPage />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="bottom-right" />
    </div>
  );
}

export default App;
